// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatListSuggestedPeopleBody = {
  query?: string | null;
  limit?: number | null;
};

export type typeChatListSuggestedPeopleOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      userId: string;
      displayName: string;
      username: string;
      avatarUrl?: string | null;
      reason: "recentChat" | "poolMate";
    }[];
    total: number;
  };
};

export type typeChatListSuggestedPeopleOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListSuggestedPeopleOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListSuggestedPeopleOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatListSuggestedPeopleBody = {
  type: "object",
  properties: {
    query: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatListSuggestedPeople(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatListSuggestedPeopleBody);
  }

  return async function postChatListSuggestedPeople(
    payload: typeChatListSuggestedPeopleBody,
  ): Promise<
    typeChatListSuggestedPeopleOutput200 | typeChatListSuggestedPeopleOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatListSuggestedPeople" failed before calling the network. #3275ac5356c5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3275ac5356c5" },
        },
        data: null,
      } as typeChatListSuggestedPeopleOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/list-suggested-people`,
      httpMethod: "POST",
      options,
    })) as
      | typeChatListSuggestedPeopleOutput200
      | typeChatListSuggestedPeopleOutput400;
  };
}
